module.exports = __webpack_public_path__ + "static/img/10013 (2).8e23a32.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10013 (2).webp
// module id = 2v1u
// module chunks = 14